export type FirestoreQuestion = {
  slideId: string
  questionType: number
  question: string
  correct: number
  answers: string[]
  groupSlideId: string
  explanation?: string | null
}

export enum PopUpIcon {
  alarm = 'alarm',
  info = 'info',
  alert = 'alert',
  thumbsup = 'thumbsup',
}
